module.exports = __webpack_public_path__ + "static/img/cont58_02.ebc49ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont58_02.jpg
// module id = vCiZ
// module chunks = 0